import { render, staticRenderFns } from "./view-app.vue?vue&type=template&id=8757d870"
import script from "./view-app.vue?vue&type=script&lang=js"
export * from "./view-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports